<!-- <div>
    <header
        class="sticky top-0 z-40  dark:bg-gray-900 px-2 py-2 flex justify-between items-center shadow-md">
        <div class="font-bold text-lg flex items-center gap-2">
            <div class="">
                <div class="flex items-center me-2">
                  <img src="images/logo.png" alt="Logo" class="h-10 md:h-14 flex-1 logoImage mr-4" />
                  <span class="text-white font-medium text-lg tracking-tight hide logo-name">
                    <span class="text-white dark:text-gray-100">
                        Pexlens
                    </span>
                    <span class="text-[#5FC9E5]">
                    </span>
                  </span>
                </div>
            </div>
            <div>
                <app-page-selector
                    (pageChange)="onPageChange($event)"
                />
            </div>

        </div>

        <div class="flex items-center text-gray-700 dark:text-gray-100">
            <app-avatar 
                [image]="profileService.profileImage()" 
                [label]="avatarLabel"
                [icon]="!profileService.profileImage() ? 'pi pi-user' : undefined" 
                [size]="'normal'"
                [customClass]="'avatarCustomClass cursor-pointer'" 

                (avatarClick)="onProfileClick()"></app-avatar>
            <div class="flex hidden sm:block text-white">
                <div class="capitalize font-semibold text-sm">
                    {{userRole}}
                </div>
                <div class="text-xs">
                    {{userEmail}}
                </div>
            </div>
        </div>


    </header>

    <app-sub-menu>
            
    </app-sub-menu>
</div> -->


<header
  class="sticky top-0 z-40 dark:bg-gray-900 px-2 py-2 flex items-center shadow-md"
>

    <!-- Mobile menu button -->
      <button
        class="mobile-menu-btn"
        type="button"
        (click)="toggleSidebar()"
        aria-label="Open navigation">

        <i class="pi pi-bars"></i>

      </button>

  <!-- LEFT: Logo -->
  <div class="flex items-center">
    <img
      src="images/logo.png"
      alt="Logo"
      class="h-10 md:h-14 logoImage mr-4"
    />

    <span class="text-white font-medium text-lg tracking-tight  logo-name">
      <span class="text-white dark:text-gray-100">
        Pexlens
      </span>
      <span class="text-[#5FC9E5]"></span>
    </span>
  </div>

  <!-- CENTER: Page Selector -->
  <div class="absolute left-1/2 -translate-x-1/2 desktop-page-selector">
    <app-page-selector
      (pageChange)="onPageChange($event)"
    />
  </div>

  <!-- RIGHT: User -->
  <div class="ml-auto flex items-center justify-items-center text-gray-700 dark:text-gray-100">
    <app-avatar
      [image]="profileService.profileImage()"
      [label]="avatarLabel"
      [icon]="!profileService.profileImage() ? 'pi pi-user' : undefined"
      [size]="'normal'"
      [customClass]="'avatarCustomClass cursor-pointer'"

    />

    <div class="hidden sm:block text-white ml-2">
      <div class="capitalize font-semibold text-sm">
        {{ userRole }}
      </div>

      <div class="text-xs">
        {{ userEmail }}
      </div>
    </div>

    <div class="theming">
        <button 
            (click)="themeService.toggle()" 
            class="group rounded-lg text-text-color transition-colors duration-200 
                    bg-transparent hover:rotate-1 flex items-center ms-3"
                    [attr.aria-label]="themeService.theme() === 'dark' ? 'Switch to light' : 'Switch to dark'">

            @if (themeService.theme() === 'dark') {


                <svg xmlns="http://www.w3.org/2000/svg" 
                    class="w-5 h-5 transition-all duration-200 
                    group-hover:stroke-yellow-400 group-hover:scale-110" 
                    fill="none" viewBox="0 0 24 24" stroke="white">

                    <path 
                        stroke-linecap="round" 
                        stroke-linejoin="round" stroke-width="2"
                        d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364-6.364l-.707.707M6.343 17.657l-.707.707M17.657 17.657l-.707-.707M6.343 6.343l-.707-.707M12 7a5 5 0 100 10A5 5 0 0012 7z" />
                </svg>

            } @else {

                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                        class="w-5 h-5 transition-all duration-200 
                            group-hover:stroke-blue-400 group-hover:scale-110" 
                            fill="none" viewBox="0 0 24 24" stroke="white">

                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
                </svg>

            }
        </button>
    </div>

    <div class="profile ms-3">
        <app-dropdown 
            [options]="profileOptions" 
            [defaultValue]="''"
            customBtnClass="profile-dropdown"
            iconColor="text-white"

            (onItemSelect)="onProfileOptionSelect($event)">
        </app-dropdown>
    </div>
  </div>
</header>

<!-- MOBILE SIDEBAR -->
<app-page-selector
  class="mobile-page-selector"
  (pageChange)="onPageChange($event)">
</app-page-selector>

<app-sub-menu></app-sub-menu>